export const GET_INVOICE_INIT = "GET_INVOICE_INIT";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_ERROR = "GET_INVOICE_ERROR";
